module.exports = __webpack_public_path__ + "img/title_about_1.8649a733.png";